export default __webpack_public_path__ + "static/media/agreement.18bed060.md";